import React from 'react';
import '../assests/CSS/empowerSection.css';
import { steps } from '../components/data';

const EmpowerSection = () => {

  const handleGetStarted = () => {
    const heroSection = document.getElementById('hero-section'); // Make sure your Hero section has id="hero-section"
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="empower-section">
      <div className="empower-left">
        <h2>How <span style={{ color: "#113157", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "1.5rem" }}>.</span> Works</h2>
        <p>
          <span style={{ color: "#113157", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "1.5rem" }}>.</span> is engineered to elevate your global procurement strategy. By allowing leading vendors to come to you with their best solutions, you can
        </p>
        <button className="empower-get-started-btn" onClick={handleGetStarted}>Get Started</button>
      </div>

      <div className="empower-right">
        {/* Desktop SVG */}
        <div className="curve-desktop">
          <svg viewBox="0 0 1071 470" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_52_887)">
              <path
                d="M27 311C75 346 186.8 412 250 396C329 376 348.5 273 470.5 249C592.5 225 682 308.5 776.5 188C871 67.5003 917 -11.4997 1044 5.50027"
                stroke="#4169E1"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_52_887"
                x="0.499756"
                y="0.703613"
                width="1070"
                height="448.255"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="24" />
                <feGaussianBlur stdDeviation="12" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.215686 0 0 0 0 0.203922 0 0 0 0 0.662745 0 0 0 0.3 0"
                />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_52_887" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_52_887" result="shape" />
              </filter>
            </defs>
          </svg>
        </div>

        {/* Mobile SVG */}
        <div className="curve-mobile">
          <svg width="322" height="793" viewBox="0 0 322 793" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_600_625)">
              <path d="M27 742L27 683C27 532.5 292 505.5 295 355C295 203.5 27 211.5 27 62.0002C27 50.5002 27 104 27 2.50018" stroke="#4169E1" strokeOpacity="0.5" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" shapeRendering="crispEdges"/>
            </g>
            <defs>
              <filter id="filter0_d_600_625" x="0.5" y="0" width="321" height="792.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="24"/>
                <feGaussianBlur stdDeviation="12"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.215686 0 0 0 0 0.203922 0 0 0 0 0.662745 0 0 0 0.3 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_600_625"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_600_625" result="shape"/>
              </filter>
            </defs>
          </svg>
        </div>

        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className={`circle circle-${index + 1}`}></div>
            <div className={`step-box step-box-${index + 1}`}>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              <span className={`bg-number bg-number-${index + 1}`}>{step.number}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default EmpowerSection;
